module.exports = __webpack_public_path__ + "images/rank_logo_tool-fd6e76795d.png";